document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header-wrapper');
    window.addEventListener('scroll', function() {
        if (window.scrollY > 50) { // Adjust number as needed
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    });
});